import { useEffect, useState } from "react";
import { FaTrash } from "react-icons/fa";
import SkeletonLoader from "../../../../components/common/SkeletonLoader";
import { useParams } from "react-router-dom";
import { hasPermission } from "../../../../helpers/utils/AccessControlUtils";
import ModalButton from "../../../../components/common/form/ModalButton";
import { FaCirclePlus } from "react-icons/fa6";
import { skipToken } from "@reduxjs/toolkit/query";
import { useDeleteAssociationNotesByIdMutation, useGetAssociationByIdQuery } from "../associationApi";
import { NoteAddSection } from "./Modal/NoteAddSection";
import AuditableInfo from "../../../../components/common/AuditableInfo";
import ConfirmationModal from "../../../../components/layout/modal/ConfirmationModal";


const AssociationNotesForm = () => {

    const { associationId } = useParams();
    const iconButtonStyle = "cursor-pointer text-md mt-1 text-highlight-0";
    const [toggleAssociationNote, setToggleAssociationNote] = useState<boolean>(false);
    const [deleteNotes, { isLoading }] = useDeleteAssociationNotesByIdMutation();

    const {
        data: notesData,
        isLoading: loading,
        isError: error,
    } = useGetAssociationByIdQuery(associationId || skipToken);

    const [noteList, setNoteList] = useState([]);

    useEffect(() => {
        if (!loading && notesData) {
            commonNoteList();
        }
    }, [toggleAssociationNote, loading, notesData]);

    function commonNoteList() {
        if (!toggleAssociationNote) {
            setNoteList(
                notesData?.notes.filter((el: any) => el.deleted === false)
            );
        } else {
            setNoteList(notesData?.notes || []);
        }
    }



    const handleDelete = async (noteId: string) => {
        if (noteId) {
            await deleteNotes(noteId).unwrap();
        }
    };


    return (
        <div className="bg-text-1 shadow-[0_3px_10px_#0003] text-sm rounded-md">
            <div className="flex justify-between items-center border-b border-[rgba(0,0,0,0.1)] p-2">
                <h5 className="font-semibold text-surface-0">Association Notes ({noteList?.length || 0})</h5>
                <i title={toggleAssociationNote ? "Hide deleted" : "Show deleted"}
                    className={toggleAssociationNote ? "text-highlight-0 fa-solid fa-toggle-on ml-auto text-lg mr-3 toggle_css" : "fa-solid fa-toggle-off text-lg ml-auto mr-3 toggle_css"}
                    onClick={() => {
                        setToggleAssociationNote(!toggleAssociationNote);
                    }}>
                </i>
                {hasPermission(["ASSOC-U"]) &&
                    <ModalButton
                        triggerButton={<FaCirclePlus className={`${iconButtonStyle} !text-highlight-0`}
                            title={"Add Note"} />}
                        modal={

                            <NoteAddSection show={true} setShow={() => {
                            }} title={"Add Note"} associationId={associationId}

                            />

                        }
                    />}


            </div>
            <div className={'p-2'}>
                <div className='overflow-y-auto max-h-32'>
                    {

                        (loading) ?
                            <SkeletonLoader className={"mt-2"} count={3}></SkeletonLoader> :
                            !error && noteList.length === 0 ?
                                <div className="border-2 border-[rgba(0,0,0,0.1)] p-2 rounded-sm bg-text-0">
                                    <h3 className="text-surface-0">
                                        No notes to display
                                    </h3>
                                </div>
                                :
                                !error && noteList?.map((data: any) => {
                                    return <div
                                        className="border-2 border-[rgba(0,0,0,0.1)] p-2 rounded-sm"
                                        style={{ backgroundColor: data?.deleted ? "#dddddd" : "#ffffff" }}
                                    >
                                        <div className="grid-cols-12 lg:grid sm:block">
                                            <div className="col-span-6">
                                                <div className="flex gap-1">

                                                    {data.deleted ? (
                                                        <FaTrash
                                                            className={`${iconButtonStyle} text-text-3 !cursor-default`}
                                                            title="Delete Note"
                                                        />
                                                    ) : hasPermission(["ASSOC-U"]) ? (
                                                        <ModalButton
                                                            triggerButton={
                                                                <FaTrash
                                                                    className={iconButtonStyle}
                                                                    title="Delete Note"
                                                                />
                                                            }
                                                            modal={
                                                                <ConfirmationModal
                                                                    show={true}
                                                                    setShow={() => { }}
                                                                    title="Delete Association Note"
                                                                    bodyMessage="Are you sure you want to delete this association note?"
                                                                    onSubmit={() => handleDelete(data.id)}
                                                                    isLoading={isLoading}
                                                                />
                                                            }
                                                        />
                                                    ) : null}

                                                    <h3 className="text-surface-2">{data?.message}</h3>
                                                </div>
                                            </div>
                                            <div className="col-span-6 text-sm text-end">
                                                <AuditableInfo data={data} />
                                            </div>
                                        </div>
                                    </div>

                                })
                    }
                </div>
            </div>
        </div>
    );
};

export default AssociationNotesForm;
